import { atom } from "recoil"

export const needUpdateGoalAtom = atom({
    key: "needUpdateGoalAtom",
    default: false
})
